import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Card
} from '@mui/material';
import loader from './loader.gif';

const Loader = () => {
  return (
    <Card>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: 'transparent' }}>
              <TableCell align="center" style={{ borderBottom: 'none' }}>
                <img
                  alt="loader"
                  src={loader}
                  className="loader"
                  width={100}
                  height={100}
                />
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default Loader;
